const q = (marketId) => `?marketId=${encodeURIComponent(marketId)}`;
export class RiderIdentityVerificationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The badge and what the market offers. */
    get(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/rider/identity-verification${q(marketId)}`, auth: true });
    }
    /** Level 1: the national id as typed (the server normalizes it with the country pack). */
    level1(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider/identity-verification/level-1', body: input, auth: true });
    }
    /** Level 2: the document photo and the live selfie (front camera). */
    level2(input) {
        return this.client.request({ method: 'POST', path: '/v1/rider/identity-verification/level-2', body: input, auth: true });
    }
}
export class AdminIdentityVerificationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    get(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/identity-verification`, auth: true });
    }
    /** One image while retained (audited before it leaves the server). */
    media(userId, verificationId, kind) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/identity-verification/${encodeURIComponent(verificationId)}/media/${kind}`, auth: true });
    }
}
//# sourceMappingURL=identity-verification.js.map